import { Component } from 'preact';
import PropTypes from "prop-types";
import { combineClasses, Jiffy } from "@green24/npm-javascript-utils";
import { settingsServices } from "../../services/utils-services";
import Loading from "../../components/shared/Loading";
import { applicationThunk } from "../../store/store";
import { withStoreConnection } from "../../components/components";
import { configurationSelector } from "../../store/selectors/selectors";

class TermsPage extends Component {
	constructor() {
		super();

		this.state = {
			loading: true,
			terms: null,
		}
	}

	componentDidMount() {
		settingsServices.getTermsPDF(this.props.locationID).then(pdf => {
			this.setState({
				terms: URL.createObjectURL(pdf),
			});
		});
		applicationThunk.setIdleTimeout(Jiffy.formatToMs("3m"));
	}

	componentWillUnmount() {
		if(this.state.terms) {
			URL.revokeObjectURL(this.state.terms);
		}
	}

	render({className, style}, {terms, loading}) {
		return (
			<section className={combineClasses("terms-page", className)} style={{
				marginTop: "6.5rem",
				...style
			}}>
				{
					loading &&
					<Loading className={"full-page big with-background"}/>
				}

				{
					terms &&
					<iframe
						type={"application/pdf"}
						src={`${terms}#toolbar=0&navpanes=0&scrollbar=0`}
						style={{
							width: "100%",
							height: "100%",
							border: 0,
							userSelect: "none"
						}}
						onLoad={() => this.setState({loading: false})}
					/>
				}
			</section>
		);
	}

	static get propTypes() {
		return {
			className: PropTypes.string,
			style: PropTypes.object,
			children: PropTypes.any,

			//Store
			locationID: PropTypes.number,
		}
	}
}

const mapStateToProps = state => {
	const { locationID } = configurationSelector.selectData(state);

	return {
		locationID,
	};
};

export default withStoreConnection(mapStateToProps)(TermsPage);
